<template lang="pug">
span
  .md-layout
    .md-layout-item.ml-auto
  .md-layout
    .md-layout-item.md-size-100.mx-auto(style='padding: 0')
      DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProvider')
        div(slot-scope='{ data: response, error, loading }')
          DataTable(
            v-if='response && response.data'
            :data='response && response.data'
            ref='dataTable'
            title="Log de Acessos"
            :customTotal='(response && response.total.value) || 0'
            @pagination='handlePagination'
            :currentSort.sync='filter.orderBy',
            :currentSortOrder.sync='filter.order',
            :selectable='false'
            :loading='loading'
            customHeader
            :endpoint='endpoint'
            :labels='labels'
            :filter='filter'
            :formatLabelFunction='formatLabels'
            fileName='log_de_acessos'
            :createHeader='createHeaderPDF')
            template(slot='footer' slot-scope='{ pagination }')
              v-row(style='justify-content: flex-end;')
                v-col(cols='auto')
                  md-field
                    label(for='pages') {{ $t('assistantsList.perPage') }}
                    md-select(v-model='pagination.perPage' name='pages' )
                      md-option(
                        v-for='item in pagination.perPageOptions',
                        :key='item',
                        :label='item',
                        :value='item')
                        | {{ item }}
            template(slot='cells' slot-scope='{ item }')
              md-table-cell(:md-label='labels[0]' md-sort-by='ts') {{ formatLabels(item, 0) }}
              md-table-cell(:md-label='labels[1]') {{  formatLabels(item, 1) }}
              md-table-cell(:md-label='labels[2]') {{  formatLabels(item, 2) }}
              md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
              md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
              md-table-cell(:md-label='labels[5]') {{  formatLabels(item, 5) }}
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import * as moment from 'moment'
import Pagination from '@/components/Pagination.vue'
import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import { selectedLocale } from '@/plugins/i18n'

export default {
  components: {
    Pagination,
    DataTable,
    DataProvider
  },
  computed: {
    ...mapFields('reports', ['dateInterval']),
    endpoint () {
      return `${process.env.VUE_APP_REPORTS_BACKEND}/event-audit/authList`
    }
  },
  data () {
    return {
      labels: [this.$t('commonWords.date'), this.$t('commonWords.user'), 'ClientIP', 'Evento', 'Detalhes', this.$t('commonWords.type')],
      resetKey: 0,
      filter: {
        order: 'desc',
        orderBy: 'ts',
        page: 0,
        perPage: 5
      }
    }
  },
  methods: {
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return this.formatDate(item, 'ts')
        case 1:
          return item._source.user
        case 2:
          return item._source.clientIP
        case 3:
          return item._source.event
        case 4:
          return item._source.result.details
        case 5:
          return item._source.result.type
        default:
          break
      }
    },
    formatDate (item, type) {
      let date = item._source[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('drawer.accessLog'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).locale(selectedLocale).format('L LTS')
      let formattedDate2 = moment(this.filter.to).locale(selectedLocale).format('L LTS')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total')
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
      this.$refs.dataProvider.load()
    }
  },
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
    this.filter.from = this.dateInterval.timestamp1
    this.filter.to = this.dateInterval.timestamp2
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  }
}
</script>
